import { render } from "./App.vue?vue&type=template&id=4ebe37f8"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "@/assets/styles/global.scss?vue&type=style&index=0&lang=scss"
import "./App.vue?vue&type=style&index=1&id=4ebe37f8&lang=css"
script.render = render

export default script